import { render, staticRenderFns } from "./VPrintButton.vue?vue&type=template&id=904bf526&"
import script from "./VPrintButton.vue?vue&type=script&lang=ts&"
export * from "./VPrintButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports